import * as React from "react";
import LocationalState from "../LocationalState";
import * as selectors from "../selectors";
import {connect} from "react-redux";
import {toggleLocationalBackend, ToggleLocationalBackend} from "../actions";

interface DispatchProps {
    doToggleLocationalBackend: ToggleLocationalBackend
}

interface StateProps {
    useSkrivLocationals: boolean;
}

const mapDispatchToProps: DispatchProps = ({
   doToggleLocationalBackend: toggleLocationalBackend
});


const mapStateToProps = (state: LocationalState): StateProps => {
    return {
        useSkrivLocationals: selectors.useSkrivLocationals(state)
    };
};

type Props = DispatchProps & StateProps;

class LocationalBackendToggleComponent extends React.Component<Props, {}> {


    render(): React.ReactNode {

        let locationalBlurb;
        let locationalButton;
        if (this.props.useSkrivLocationals) {
            locationalBlurb = <p>Du bruker nå Datafangsts nye stedfestingsmetode. Den er fortsatt under utprøving, så vi vil gjerne
                                     høre om alle feil. Hvis det er noe som ikke virker kan du prøve å bytte til gammel stedfesting.</p>

            locationalButton = "Bytt til gammel stedfesting";
        } else {
            locationalBlurb = <p>Du bruker nå Datafangsts gamle stedfestingsmetode. Den har en del kjente feil,
                                 men kan virke bedre i noen tilfeller. </p>
            locationalButton = "Bytt til ny stedfesting";
        }

        return (
            <div className={"locational-backend-toggle"}>
                <div className={"infobox"}>
                    {locationalBlurb}
                    <button className={"btn"} onClick={() => this.props.doToggleLocationalBackend()}>{locationalButton}</button>
                </div>
            </div>
        );
    }
}

export const LocationalBackedToggle = connect(mapStateToProps, mapDispatchToProps)(LocationalBackendToggleComponent);